//libs and utilities
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { fetchSalesTools } from './sales-tools-dux';
import { fetchUserLogin } from '../header/header-dux';

/*   Components
 *
 *   1. Sales Tools
 *
 */

export class SalesTools extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			selected: this.props.selected || 0
		}
	}

	componentDidMount() {
		this.props.fetchSalesTools();
		this.props.fetchUserLogin();
		window.scrollTo(0, 0);
	}

	handleChange(index) {
		this.setState({ selected: index });
		this.props.location.param = undefined;
	}

	render() {
		let sales = this.props.sales;
		let content = sales.pageData;
		let paramVal = this.props.location.param;
		const { location } = window;
		let imageLocation = '';
		if (location.hostname === "localhost" && location.port == "3001") {
			imageLocation = "images/";
		} else {
			imageLocation = location.origin + '/wholesalechannelpartners/images/';
		}
		return (
			<section className={this.props.headerState != null ? "sales " + this.props.headerState.paxAudienceType : "sales default"}>
				{content != undefined &&
					<div className="container">
						<div className="title"></div>
						<div className="sales-data">
							<div className="sales-icons">
								{content[0] &&
									content[0].tabName &&
									<div className="list">
										<div className="icon"><img className={paramVal == undefined && this.state.selected == 0 ? "selected" : paramVal == 0 ? "selected" : ''} src={imageLocation + "tools.png"} onClick={this.handleChange.bind(this, 0)} /></div>
										<div className="listName">{content[0].tabName}</div>
									</div>
								}
								{content[1] &&
									content[1].tabName &&
									<div className="list">
										<div className="icon"><img className={paramVal == undefined && this.state.selected == 1 ? "selected" : paramVal == 1 ? "selected" : ''} src={imageLocation + "resources.png"} onClick={this.handleChange.bind(this, 1)} /></div>
										<div className="listName">{content[1].tabName}</div>
									</div>
								}
								{content[2] &&
									content[2].tabName &&
									<div className="list">
										<div className="icon">
										<img className={paramVal == undefined && this.state.selected == 2 ? "selected" : paramVal == 2 ? "selected" : ''} src={imageLocation + "university.png"} onClick={this.handleChange.bind(this, 2)} /></div>
										<div className="listName">{content[2].tabName}</div>
									</div>
								}
								{content[3] &&
									content[3].tabName &&
									<div className="list">
										<div className="icon"><img className={paramVal == undefined && this.state.selected == 3 ? "selected" : paramVal == 3 ? "selected" : ''} src={content[3].tabName == 'Value Prop Videos'  ? imageLocation+"video.png" : imageLocation+"merchandise.png" } 
										onClick={this.handleChange.bind(this, 3)} />
										</div>
										<div className="listName">{content[3].tabName}</div>
									</div>
								}
								{content[4] &&
									content[4].tabName &&
									<div className="list">
										<div className="icon"><img className={paramVal == undefined && this.state.selected == 4 ? "selected" : paramVal == 4 ? "selected" : ''} src={imageLocation + "merchandise.png"} onClick={this.handleChange.bind(this, 4)} /></div>
										<div className="listName">{content[4].tabName}</div>
									</div>
								}
							</div>
							{paramVal == undefined ?
								<div className="sale-details">
									<div className="tabHeader" dangerouslySetInnerHTML={{ __html: content[this.state.selected].header }} />
									<div className="instrctions" dangerouslySetInnerHTML={{ __html: content[this.state.selected].instrctions }} />
									<div className="list" dangerouslySetInnerHTML={{ __html: content[this.state.selected].list }} />
								</div> :
								<div className="sale-details">
									<div className="tabHeader" dangerouslySetInnerHTML={{ __html: content[paramVal].header }} />
									<div className="instrctions" dangerouslySetInnerHTML={{ __html: content[paramVal].instrctions }} />
									<div className="list" dangerouslySetInnerHTML={{ __html: content[paramVal].list }} />
								</div>
							}
						</div>
					</div>
				}
			</section>
		);
	}
}

export default connect(
	(state) => {
		return {
			sales: state.sales,
			headerState: state.headerState.audienceType
		};
	},
	(dispatch) => bindActionCreators({ fetchSalesTools, fetchUserLogin }, dispatch)
)(SalesTools);



// WEBPACK FOOTER //
// ./src/sales-tools/sales-tools.jsx